<template>
  <v-row justify="center">
    <v-dialog persistent :width="cf_width" :value="cf_dialog">
      <v-card>
        <v-card-title class="headline"> {{ cf_title }} </v-card-title>
        <v-card-text>{{ cf_text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :outlined="cf_style_btn"
            :color="cf_color_btn2"
            @click="$emit('cancel', false)"
            class="text-capitalize"
          >
            {{ cf_btn2 }}
          </v-btn>
          <v-btn
            :outlined="cf_style_btn"
            :color="cf_color_btn1"
            @click="$emit('active', false)"
            dark
            class="text-capitalize"
          >
            {{ cf_btn1 }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "confirmDialog",
  props: {
    cf_dialog: Boolean,
    cf_title: String,
    cf_text: String,
    cf_style_btn: {
      type: Boolean,
      default: false,
    },
    cf_width: {
      type: String,
      default: "450",
    },
    cf_color_btn1: {
      type: String,
      default: "success",
    },
    cf_color_btn2: {
      type: String,
      default: "",
    },
    cf_btn1: {
      type: String,
      default: "Confirm",
    },
    cf_btn2: {
      type: String,
      default: "Cancel",
    },
  },
};
</script>

<style></style>
